import React, { PureComponent } from "react";
import { Link } from "react-router";
import { changeLocation } from "api/Location";
import Logo from "../containers/assets/LandingPageLogo.png";
import { postRequest } from "../api/ApiService";
import { logError, detectMobile, getLogoStyle } from "./utils";

const RESET_PASSWORD_URL = `${process.env.REACT_APP_API_URL}account/reset/`;

class ResetPassword extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      new_password: "",
      new_password_2: "",
      validations: {}
    };

    this.isMobile = detectMobile();
  }

  handleInputChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  onSubmit = e => {
    e.preventDefault();
  };

  hasError = key => {
    const { validations } = this.state;

    if (key in validations && validations[key] !== "") {
      return "form-group has-error register-error";
    }

    return "form-group";
  };

  getError = key => {
    const { validations } = this.state;

    if (key in validations && validations[key] !== "") {
      return <span className="help-block">{validations[key]}</span>;
    }

    return null;
  };

  submit = () => {
    let data = {};
    const keys = ["new_password", "new_password_2"];

    keys.forEach(key => {
      if (this.state[key] && this.state[key] !== "") {
        data[key] = this.state[key];
      }
    });

    const { token1, token2 } = this.props;

    postRequest(`${RESET_PASSWORD_URL}${token1}/${token2}/`)
      .send(data)
      .then(response => {
        changeLocation("/login?reset_password=1");
      })
      .catch(err => {
        if (err.response && err.response.statusCode === 400) {
          this.setState({
            validations: err.response.body
          });
        } else {
          logError(err, "ResetPassword", "submit");
        }
      });
  };

  render() {
    const { new_password, new_password_2 } = this.state;
    const logoStyle = getLogoStyle(this.isMobile);
    const formClass = this.isMobile ? "mg-top-5vh" : "mg-top-10vh";
    const buttonStyle = this.isMobile
      ? {
          paddingTop: "20px"
        }
      : {};

    return (
      <div className="container-fluid bg-color-blue height-100vh">
        <div className="text-center mg-top-15vh">
          <Link to="/welcome">
            <img src={Logo} style={logoStyle} alt="Logo" />
          </Link>
        </div>
        <div className={formClass}>
          <form
            className="form-signin form-horizontal"
            onSubmit={this.onSubmit}
          >
            <div className={this.hasError("new_password")}>
              <label
                htmlFor="new_password"
                className="control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
              >
                New password
              </label>
              <div className="col-md-3 col-xs-12">
                <input
                  id="new_password"
                  type="password"
                  value={new_password}
                  onChange={this.handleInputChange}
                  className="form-control border-radius-none"
                  placeholder="New password"
                  required={true}
                  autoFocus={!this.isMobile}
                />
                {this.getError("new_password")}
              </div>
            </div>
            <div className={this.hasError("new_password_2")}>
              <label
                htmlFor="new_password_2"
                className="control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
              >
                Confirm new password
              </label>
              <div className="col-md-3 col-xs-12">
                <input
                  id="new_password_2"
                  type="password"
                  value={new_password_2}
                  onChange={this.handleInputChange}
                  className="form-control border-radius-none"
                  placeholder="Confirm new password"
                  required={true}
                />
                {this.getError("new_password_2")}
              </div>
            </div>
            <div className="form-group mg-top-3vh" style={buttonStyle}>
              <div className="col-md-2 col-md-offset-6 col-xs-12">
                <button
                  type="submit"
                  onClick={this.submit}
                  className="btn login-btn btn-lg btn-block"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/services/reset-password.js